export const commonActionTypes = {
  OPEN_CREATE_OBJECT_MODAL: 'OPEN_CREATE_OBJECT_MODAL',
  OPEN_CREATE_SINGER_MODAL: 'OPEN_CREATE_SINGER_MODAL',
  OPEN_CREATE_STAFF_MODAL: 'OPEN_CREATE_STAFF_MODAL',
  OPEN_CONFIRM_MODAL: 'OPEN_CONFIRM_MODAL',
  SET_USER: 'SET_USER',
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  SET_LOADING: 'SET_LOADING',
}
